import React from 'react';

const SingleImage = ({ input: { primary: { image: { alt, url } } } }) =>
  <img alt={alt} src={url} />

export default SingleImage
